import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	position: sticky;
	top: -${helpers.spacing.large};
	display: flex;
	column-gap: ${helpers.spacing.medium};
	align-items: center;
	font: ${helpers.fonts.headline.medium};
	justify-content: space-between;
	margin: -${helpers.spacing.large} -${helpers.spacing.large} ${helpers.spacing.medium};
	padding: ${helpers.spacing.xxLarge} ${helpers.spacing.large} ${helpers.spacing.large};
	background-color: ${({ theme }) => theme.color.cardBackground};
	z-index: 3;
`
